import { ABSOLUTE_MAX_ORDER_QUANTITY, MAX_ORDER_QUANTITY } from "./constants";

/**
 * Effective max for a product quantity stepper (SFCC-11812). The tightest
 * *real* limit wins, by precedence — not the min of everything:
 *
 *   cMaxOrderQuantity  ??  stock  ??  hardcodedCap
 *
 * i.e. use the per-product order limit if we have it, else live stock, else the
 * hardcoded UX cap. The 150 fallback therefore applies ONLY when neither a
 * per-product limit nor a stock number is supplied — which is exactly the PLP
 * tile case (CIO returns no stock), so those callers get 150 for free just by
 * calling with no stock. The result is then bounded by SCAPI's hard 1000
 * per-line ceiling and floored at 0 (a 0-stock or 0-limit product honestly caps
 * at 0; callers gate out-of-stock separately, so it needn't be faked up to 1).
 *
 * @param stock              Live available-to-sell (`inventory.ats`). Omit when
 *                           the surface has no numeric stock (e.g. CIO tiles).
 * @param cMaxOrderQuantity  Per-product order limit (`c_maxOrderQuantity`).
 *                           Unpopulated in the realm today (verified 0/102 live
 *                           products) so effectively always `undefined` — wired
 *                           so it takes precedence for free once it's set.
 * @param hardcodedCap       Fallback UX ceiling (default `MAX_ORDER_QUANTITY`
 *                           = 150, SFRA `maxLineItemQuantity`). Used only when
 *                           stock + cMaxOrderQuantity are both absent.
 */
export function resolveQuantityCap(
  stock?: number | null,
  cMaxOrderQuantity?: number | null,
  hardcodedCap: number = MAX_ORDER_QUANTITY,
): number {
  const cap = cMaxOrderQuantity ?? stock ?? hardcodedCap;
  return Math.max(0, Math.min(cap, ABSOLUTE_MAX_ORDER_QUANTITY));
}
